import CallIcon from '@ixigo/icons/Call';
import MailIcon from '@ixigo/icons/Mail';
import Typography from '@ixigo/iui/Typography';
import type { BaseContactDetail } from '@/api';
import { SectionHeader } from '../section-header';
import type { ContactDetailBaseProps } from './ContactDetail';

export interface ContactDetailViewProps extends ContactDetailBaseProps {
	contactDetails: BaseContactDetail;
}

export function ContactDetailView({
	title = 'Contact Details',
	subtitle,
	contactDetails,
}: ContactDetailViewProps) {
	const { email, mobileInfo } = contactDetails;

	return (
		<div className="bg-primary p-20 flex flex-col gap-[15px]">
			<div className="flex flex-col">
				<SectionHeader title={title} />
				<Typography variant="body-sm" className="text-secondary">
					{subtitle}
				</Typography>
			</div>

			<div className="flex flex-col gap-2.5">
				<div className="flex gap-x-5">
					<MailIcon />
					<Typography variant="body-sm">{email}</Typography>
				</div>

				<div className="flex gap-x-5">
					<CallIcon />
					<Typography variant="body-sm">
						+{mobileInfo.isdInfo.number}&nbsp;{mobileInfo.number}
					</Typography>
				</div>
			</div>
		</div>
	);
}
